import axios from 'src/utils/axios';
import getApiUrl from 'src/utils/get-api-url';

const baseUrl = getApiUrl();

export function getAllocationTypeOptions() {
  return axios.get(`${baseUrl}/lever/position-closed-options`)
}
